import throttle from "lodash.throttle";
import {
  CLICKED_CATEGORY_READER,
  CLOSED_CATEGORY_DROPDOWN_READER,
  OPENED_CATEGORY_DROPDOWN_READER,
} from "./../../../common/analytics/analyticsevents";
import logger from "./../../../common/utilities/logger";
import template from "./../templates/categoriesPickerComponent.dust";

export default class CategoriesPickerComponent {
  constructor(pubStore, appState, options) {
    this._pubStore = pubStore;
    this._appState = appState;
    this.DOMContainer = document.querySelector(".top-bar-center");
    this._options = options;
    this._appState.on(
      "appState:currentpagechanged",
      this._onPageChanged.bind(this)
    );
    this._pubStore.on("pubStore:pubLoaded", this.render.bind(this));
    this._attachEventListeners();
  }

  render() {
    if (!this.DOMContainer) {
      logger.error("Node with class .top-bar-middle-section not found");
      return;
    }

    this.DOMContainer.classList.add("invisible");
    const context = this._prepareContext();

    Dust.render(template, context, (err, result) => {
      this.DOMContainer.innerHTML = result;
      setTimeout(() => {
        // Safari has problem with counting correct items dimentions
        // right away after innerHTML
        this._reRenderIfNotEnoughSpace(context);
      }, 10);
    });
  }

  ////////

  _attachEventListeners() {
    $(".top-bar-center").on(
      "click",
      ".categories-picker-item-more",
      this._toggleDropdown.bind(this)
    );
    $(".top-bar-center").on(
      "click",
      ".categories-picker-item:not(.categories-picker-item-more)",
      this._goToCategory.bind(this)
    );
    this._appState.on("alb:overlayClicked", this._closeDropDown);
    this._appState.on("cropper:overlayClicked", this._closeDropDown);
    this._appState.on("readerContainer:clicked", this._closeDropDown);
    this._appState.on("replicaReader:clicked", this._closeDropDown);
    this._appState.on("imageGallery:opened", this._closeDropDown);
    this._appState.on("downloadButton:clicked", this._closeDropDown);
    this._appState.on("printButton:clicked", this._closeDropDown);
    this._appState.on("settingButton:clicked", this._closeDropDown);
    this._appState.on("appState:currentpagechanged", this._closeDropDown);
    this._appState.on("readerReadingMode:clicked", this._closeDropDown);
    window.addEventListener("resize", throttle(this.render.bind(this), 300));
  }

  _toggleDropdown() {
    if (
      $(".categories-picker-dropdown").hasClass(
        "categories-picker-dropdown-is-hidden"
      )
    ) {
      $(".categories-picker-dropdown").removeClass(
        "categories-picker-dropdown-is-hidden"
      );
      this._appState.triggerEvent(OPENED_CATEGORY_DROPDOWN_READER);
      this._appState.trigger("categoryDropdown:opened");
    } else {
      $(".categories-picker-dropdown").addClass(
        "categories-picker-dropdown-is-hidden"
      );
      this._appState.triggerEvent(CLOSED_CATEGORY_DROPDOWN_READER);
    }
  }

  _closeDropDown = () => {
    if (
      !$(".categories-picker-dropdown").hasClass(
        "categories-picker-dropdown-is-hidden"
      )
    ) {
      $(".categories-picker-dropdown").addClass(
        "categories-picker-dropdown-is-hidden"
      );
      this._appState.triggerEvent(CLOSED_CATEGORY_DROPDOWN_READER);
    }
  };

  _onPageChanged() {
    const currentCategoryEl =
      this.DOMContainer.querySelector("#current-category");

    if (currentCategoryEl) {
      currentCategoryEl.textContent = this._getCurrentCategoryName();
    }

    this._selectCategory();
  }

  _selectCategory() {
    const pageCategory = this._getCurrentCategoryName();
    $(".categories-picker-item").removeClass("selected");
    $(`.categories-picker-item[data-value="${pageCategory}"]`).addClass(
      "selected"
    );
  }

  _goToCategory(e) {
    e.stopPropagation();
    this._toggleDropdown();
    if (typeof e.target.dataset.firstpageindex !== "undefined") {
      this._appState.changeCurrentPage(e.target.dataset.firstpageindex);
    }
    const selectedcategory = { selectedSection: e.target.dataset.value };
    this._appState.triggerEvent(
      CLICKED_CATEGORY_READER,
      selectedcategory,
      true
    );
  }

  _reRenderIfNotEnoughSpace(context) {
    const logoContainer = document.querySelector(".top-bar-logo");
    const topBarMenu = document.querySelector(".top-bar-access");
    const containerAvailableSpace =
      this.DOMContainer.offsetWidth -
      logoContainer.offsetWidth -
      topBarMenu.offsetWidth;
    const items = this.DOMContainer.querySelectorAll(".categories-picker-item");
    const { categories } = context;
    let itemsWidth = 0;
    const currentCategory = this._findCategoryByName(
      this._getCurrentCategoryName()
    );

    itemsWidth = [].reduce.call(
      items,
      (acc, item) => {
        acc += item.clientWidth; // eslint-disable-line
        return acc;
      },
      0
    );

    if (
      this._options.reader.enableTopNavDropdown ||
      itemsWidth > containerAvailableSpace
    ) {
      this._reRender(currentCategory, categories);
    }

    this.DOMContainer.classList.remove("invisible");
    this._selectCategory();
  }

  _findCategoryByName(catName) {
    const categories = this._pubStore.extractUniqueCategories();
    for (let i = 0, len = categories.length; i < len; i++) {
      if (categories[i].name === catName) {
        return categories[i];
      }
    }
  }

  _reRender(currentCategory, moreCategories) {
    const context = {
      currentCategory,
      showMore: true,
      moreCategories,
    };

    Dust.render(template, context, (err, result) => {
      this.DOMContainer.innerHTML = result;
    });
  }

  _getCurrentCategoryName() {
    let rightPage = null;
    const currentPage =
      this._pubStore.CPackagePages[this._appState.currentPage];
    if (currentPage.PagePositionType === "Left") {
      rightPage = this._pubStore.CPackagePages[this._appState.currentPage + 1];
    }
    return rightPage ? rightPage.PageCategory : currentPage.PageCategory;
  }

  _prepareContext() {
    const context = {};
    context.categories = this._pubStore.extractUniqueCategories();
    return context;
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/categoriesPickerComponent.js